const { sm2 } = require('sm-crypto');

const cipherMode = 1; // 1 - C1C3C2，0 - C1C2C3，默认为1
const publicKey = '047eb420d7a6e19c858d525aeeab4b642d9daad20cb3a8eed08265ed4d0655ba84268cc2be221928ae89b6b3fec4edbb02ea3ee8beea0bce82d5b9abc08f62cd90';

export function sm2Encrypt(value, doEncrypt = true) {
  return doEncrypt ? sm2.doEncrypt(value, publicKey, cipherMode) : value;
}
